import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { handleRadioChange } from "../actions";
import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";

import Button from "common-components/Buttons";
import { TitleLockup } from "@vds/type-lockups";
import { RadioButton } from "@vds/radio-buttons";
import CommonHeader from "common-components/Header";
import CommonContainer from "common-components/Container";
// import { Radio } from "common-components/FormContent";
import { media , isMobile } from "utils/style";

class FileFormatSelection extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("File format selection", this.props.pageContent.sc_pagetitle);
    }
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.history.push({
      pathname: "/privacy/secure/review-download",
      state: {
        confirmAuth: true
      }
    });
  };

  render() {
    const { pageContent } = this.props;

    if (!pageContent) {
      return <Redirect to="/privacy/secure/your-data" />;
    }
    return (
      <Container>
          <TitleLockup 
              surface= 'light'
              textAlignment= 'left'
              viewport={isMobile ? "mobile": "desktop"}
              data={{
                 title:{
                  size:'titleXLarge',
                  bold: false,
                  children: convertStringToElements(pageContent.section_title)
                 },
                 subtitle:{
                    size: 'bodyLarge',
                    children: <Div>{convertStringToElements(pageContent.section_description)}</Div>
                    }

               }}   
        />
        {/* <Header>{convertStringToElements(pageContent.section_title)}</Header>
        <Div>{convertStringToElements(pageContent.section_description)}</Div> */}
        <form onSubmit={this.handleSubmit}>
          <fieldset style={{ margin: "32px 0 48px 0" }}>
            <Legend>{pageContent.genericList[0].text}</Legend>
            {pageContent.genericList[0].list.map(item => (
              <div key={item.jsonKey} style={{ margin: "20px 20px" }}>
                <RadioButton
                  name="fileFormat"
                  value={item.uniqueId}
                  children={<span style={{marginLeft:"-28px"}}>{item.jsonKey}</span>}
                  onChange={this.props.handleRadioChange}
                  selected={item.uniqueId === this.props.fileFormat}
                />
              </div>
            ))}
          </fieldset>
          <Button type="submit" background={pageContent.buttons[0].type}>
            {pageContent.buttons[0].text}
          </Button>
        </form>
      </Container>
    );
  }
}

const mapStateToProps = ({
  pageContent: { "download-file-format": pageContent },
  downloadInputInformation: { fileFormat }
}) => ({
  pageContent,
  fileFormat
});

FileFormatSelection.propTypes = {
  handleRadioChange: PropTypes.func.isRequired,
  setA11yContent: PropTypes.func.isRequired,
  pageContent: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  {
    setA11yContent,
    handleRadioChange
  }
)(FileFormatSelection);

const Div = styled.div`
  max-width: 596px;
  p {
    margin-bottom: 18px;
  }

  p:first-of-type {
    font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    color: #6F7171;
    margin-bottom:28px;
  }
`;

const Legend = styled.legend`
  font-size: 16px;
  line-height: 20px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  margin-bottom: 24px;
  font-weight: 700;
`;

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
    margin: 0;
    padding: 32px 16px ;
  `}
`;

const Header = styled(CommonHeader)`
  max-width: 598px;
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 12px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight: 300;

${media.mobile`
  font-size: 32px;	
  line-height: 36px;
  font-weight: 300;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
`}
`;


